module.exports = __webpack_public_path__ + "img/banana_no.833c9bf4.png";